export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13538.f9fe209c.jpg";